define('views/modules/calendar/animated-session/session/form/session-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/form/textbox',
    'views/parts/form/textarea',
    'views/parts/form/datepicker',
    'views/parts/form/select',
    // templates
    'text!templates/modules/calendar/animated-session/session/form/session-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    //services
    i18n,
    // views
    VTextBox,
    VTextArea,
    VDatePicker,
    VSelect,
    // templates
    TSessionForm
) {

    var VSessionForm = Backbone.View.extend({
        template: TSessionForm,

        events: {
            'click .open-note button': 'onToggleNoteClick'
        },

        regions: {

            name: '.name-input',
            note: {
                section: '.content-note',
                input: '.note-input',
            },
            week: '.week-input',
            date: '.date-input'
                // submit: '.submit-button'
        },

        defaults: {
            weekOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        },
        initialize: function(opt) {
            this.options = opt || {};
            // default views for minimal member edition
            var textBoxAttributeName = this.options.attributes && this.options.attributes.textBox ? this.options.attributes.textBox : 'name';
            this.view = {
                name: new VTextBox({ label: 'Name', labelposition: "top", attribute: textBoxAttributeName, model: this.model, validation: true, autocomplete: false }),
                date: new VDatePicker({ label: 'Date', attribute: '_date', labelposition: "top", model: this.model }),
                note: new VTextArea({ label: 'note:Notes', labelposition: "top", attribute: 'notes', rows: 4, model: this.model, markdownHelp: true }),
            };

            this.listenTo(this.model, {
                "model:reset": this.render,
            });

            this.notCalledFromTemplate = Boolean(this.model.get("_date"));
        },
        render: function() {
            
            if (this.model.get('num_weeks') !== undefined) {
                this.view.week = new VSelect({ label: 'Duration (week)', labelposition: "top", attribute: 'num_weeks', filter: "integer", model: this.model, collection: this.defaults.weekOptions }) 
            }

            // append the form
            this.$el.empty().append(Mustache.to_html(this.template, Mustache.getContext({
                "new": this.model.isNew(), notCalledFromTemplate: this.notCalledFromTemplate
            })));

            this.generateZones().assign(this.view.name, this.zone.$name)

            if (this.view.note) {
                this.generateZones().assign(this.view.note, this.zone.note.$input)
            }
            if (this.view.week) {
                this.generateZones().assign(this.view.week, this.zone.$week);
            }

            if (this.model.isNew()) {
                this.assign(this.view.date, this.zone.$date);
            }

            
            return this;
        },

        toggleNote: function(val) {
            var $el = this.zone.note.$section,
                duration = 125;
            if (_.isUndefined(val)) {
                $el.slideToggle(duration);
            } else if (val) {
                $el.slideDown(duration);
            } else {
                $el.slideUp(duration);
            }
            // this.zone.note.$section.toggleClass("hidden", val);
        },

        ////////////
        // events //
        ////////////
        onToggleNoteClick: function(e) {
            this.toggleNote();
        },

    });

    return VSessionForm;

});

